import React, { createContext, useReducer } from 'react';
import AppReducer from './AppReducer';
import {
  SELECT_PRODUCT_ID,
  SELECT_PB_ID,
  SELECT_BILL_ID,
  SELECT_UNIT,
  SELECT_VERBIAGE,
  SELECT_TEMP_ACTIVE_PRODUCT_ID,
  SELECT_PRODUCT,
  SELECT_BILL,
} from './Types';

// Initial state
const initialState = {
  productId: null,
  pbId: null,
  billId: null,
  unit: null,
  verbiage: null,
  tempActiveProductId: null,
  selectedProduct: null,
  selectedBill: null,
};

// Create context
export const GlobalContext = createContext(initialState);

// Provider component
export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  // Actions
  function selectProductId(id) {
    dispatch({
      type: SELECT_PRODUCT_ID,
      payload: id,
    });
  }

  function selectPbId(id) {
    dispatch({
      type: SELECT_PB_ID,
      payload: id,
    });
  }

  function selectBillId(id) {
    dispatch({
      type: SELECT_BILL_ID,
      payload: id,
    });
  }

  function selectUnit(unit) {
    dispatch({
      type: SELECT_UNIT,
      payload: unit,
    });
  }

  function selectVerbiage(verbiage) {
    dispatch({
      type: SELECT_VERBIAGE,
      payload: verbiage,
    });
  }
  function selectTempActiveProductId(id) {
    dispatch({
      type: SELECT_TEMP_ACTIVE_PRODUCT_ID,
      payload: id,
    });
  }

  function selectProduct(product) {
    dispatch({
      type: SELECT_PRODUCT,
      payload: product,
    });
  }
  function selectBill(bill) {
    dispatch({
      type: SELECT_BILL,
      payload: bill,
    });
  }

  return (
    <GlobalContext.Provider
      value={{
        productId: state.productId,
        pbId: state.pbId,
        billId: state.billId,
        unit: state.unit,
        verbiage: state.verbiage,
        tempActiveProductId: state.tempActiveProductId,
        selectedProduct: state.selectedProduct,
        selectedBill: state.selectedBill,
        selectProductId,
        selectPbId,
        selectBillId,
        selectUnit,
        selectVerbiage,
        selectTempActiveProductId,
        selectProduct,
        selectBill,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
